module.exports = __webpack_public_path__ + "media/V98.38bcba33.mp4";